// See React on Rails Pro's spec/loadable/README.md  for details regarding **.imports-X.** file extension & duplicate file structure.
import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { loadableReady } from '@loadable/component';

import ClientApp from '../../../javascripts/App';

const App = (props, _railsContext, domNodeId) => {
  const root = document.getElementById(domNodeId);
  const app = React.createElement(ClientApp, { ...props, railsContext: _railsContext });

  // SSR
  if (root && root.innerHTML.trim()) {
    loadableReady(() => {
      hydrateRoot(root, app);
    });

  // CSR
  } else {
    createRoot(root).render(app);
  }
};

export default App;
